import { CtStorageType } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'string',
      required: true,
      default: 'storage-medium'
    },
    dimensions: {
      field: 'dimensions',
      label: 'Dimensions',
      validator: () => true,
      type: 'json',
      required: false
    },
    volume: {
      field: 'volume',
      label: 'Volume',
      validator: () => true,
      type: 'number',
      required: false
    },
    material: {
      field: 'material',
      label: 'Material',
      validator: () => true,
      type: 'string',
      required: true
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtStorageType>(
  ContentType.StorageType, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
